import React, { Component } from 'react';
import Switch from '../../Part_Sample/Switch';
import Timer_On from '../../../Images/Cell_Status_Icon/Offtimer/offtimer-green.png';
import Timer_Off from '../../../Images/Cell_Status_Icon/Offtimer/offtimer-gray.png';

export default class Command_Off_Timer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_enabled: this.props.action_details.off_timer != null ? true : false,
			off_timer: this.props.action_details.off_timer != null ? this.props.action_details.off_timer : 'off'
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.off_timer != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let off_timer = nextProps.action_details.off_timer != null ? nextProps.action_details.off_timer : 'off';

		if (off_timer != nextState.off_timer) {
			this.setState({
				off_timer: off_timer
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !(this.props.action_details.off_timer != null ? true : false)
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeOffTimer(this.state.off_timer);
		} else {
			this.props.handleChangeOffTimer(null);
		}
	}

	handleOnClick = () => {
		if (this.state.is_enabled) {
			let off_timer = 'on'
			if (this.state.off_timer == 'on') {
				off_timer = 'off'
			}

			//let off_timer = !this.state.off_timer;
			this.setState({ off_timer: off_timer });
			this.props.handleChangeOffTimer(off_timer);
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}


		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 120 }}>
					<span>{this.props.receiver.getString('off_timer')}</span>
				</div>
				<div style={{ cursor: 'pointer', display: 'inline-block', verticalAlign: 'top' }} onClick={this.handleOnClick}>
					<img src={this.state.off_timer == 'on' ? Timer_On : Timer_Off} style={{ width: 25, }} />
				</div>
			</div>
		)
	}
}